import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Grid, Box, Fade } from "@mui/material"
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { fetchNotice } from '../../store/features/notification';
import { useDispatch, useSelector } from 'react-redux';

export default function Example() {

  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { data } = useSelector((store) => (store.notification))

  useEffect(() => {
    // dispatch(fetchNotice());
    setShow(true);
  }, []);

  const Item = ({ children, date }) => {
    return (
      <Grid item xs={12}>
        <Paper className='w-full m-auto mt-2' sx={{ boxShadow: 'none' }}>
          <div className='border p-2 rounded-lg w-full'>
            <div dangerouslySetInnerHTML={{ __html: children }}></div>
            <div className='mt-5 flex items-center content-center flex-row-reverse text-xs text-slate-400	'>
              {date}
              <AccessTimeOutlinedIcon fontSize="small" sx={{ color: "#D9D9D9" }}></AccessTimeOutlinedIcon>

            </div>
          </div>
        </Paper>
      </Grid>
    );
  };

  return (
    <Fade in={show}>
      <Container className='text-mblack' sx={{ marginTop: '5rem' }}>
        <div className='mt-2 mb-2'>通知列表</div>
        <Grid container direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {
            (data && data.length > 0) && data.map((item, index) => (
              item.stype == 1 && <Item key={index} date={item.name}>{item.desc}</Item>
            ))
          }

          <Box className='mb-10 opacity-0'>1</Box>
        </Grid>


      </Container >
    </Fade>
  );
}